module.exports = __webpack_public_path__ + "static/media/tick.e79fbd5c.svg";